import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { useInView } from '../../../hooks/useInView';

const FinalCTA = () => {
  const [ref, isInView] = useInView({ threshold: 0.3 });

  const scrollToQuoteForm = () => {
    const quoteForm = document.getElementById('homepage-quote-request');
    if (quoteForm) {
      quoteForm.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <section ref={ref} className="py-20 lg:py-28 bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 relative overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute inset-0" style={{
          backgroundImage: 'radial-gradient(circle at 2px 2px, white 1px, transparent 0)',
          backgroundSize: '40px 40px'
        }}></div>
      </div>

      <div className="max-w-5xl mx-auto px-6 lg:px-12 text-center relative z-10">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6 }}
        >
          <div className="inline-flex items-center px-4 py-2 bg-white/10 backdrop-blur-sm rounded-full text-white text-sm font-medium mb-6">
            <i className="ri-price-tag-3-line mr-2"></i>
            Save 20-40% on Your Next Project
          </div>

          <h2 className="font-display font-light text-4xl md:text-5xl lg:text-6xl text-white mb-6">
            Ready to Reduce Your <span className="font-semibold">Construction Costs?</span>
          </h2>
          
          <p className="text-xl text-white/90 mb-12 max-w-3xl mx-auto leading-relaxed">
            Get a free material cost comparison and see exactly how much you can save by buying direct from global manufacturers
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-12">
            <button
              onClick={scrollToQuoteForm}
              className="inline-flex items-center justify-center px-10 py-4 bg-white text-gray-900 text-base font-semibold rounded-full hover:shadow-2xl transition-all duration-300 hover:scale-105 whitespace-nowrap cursor-pointer"
            >
              Get Free Cost Comparison
              <i className="ri-arrow-right-line ml-2"></i>
            </button>
            <Link
              to="/contact"
              className="inline-flex items-center justify-center px-10 py-4 border-2 border-white text-white text-base font-semibold rounded-full hover:bg-white/10 transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              Talk to Our Team
              <i className="ri-phone-line ml-2"></i>
            </Link>
          </div>

          {/* Trust Indicators */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 pt-12 border-t border-white/10">
            <div className="text-center">
              <div className="text-3xl font-bold text-white mb-2">24-48h</div>
              <div className="text-sm text-white/70">Quote Turnaround</div>
            </div>
            <div className="text-center">
              <div className="text-3xl font-bold text-white mb-2">20-40%</div>
              <div className="text-sm text-white/70">Average Savings</div>
            </div>
            <div className="text-center">
              <div className="text-3xl font-bold text-white mb-2">100%</div>
              <div className="text-sm text-white/70">Transparent Pricing</div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default FinalCTA;